import React from "react";
import { MapPin, Briefcase, ArrowRight, Heart, Rocket, Users } from "lucide-react";
import { jobs, images } from "../mock/mock";
import { PageHero, SectionHeading, PrimaryButton, CTABanner } from "../components/Common";

const perks = [
  { Icon: Rocket, title: "Growth & Training", desc: "Continuous coaching, certifications and clear paths for career advancement." },
  { Icon: Heart, title: "Supportive Culture", desc: "A collaborative, people-first environment where your work truly matters." },
  { Icon: Users, title: "Global Team", desc: "Work with talented colleagues across the USA and India on impactful programs." },
];

const Jobs = () => {
  return (
    <div>
      <PageHero
        eyebrow="Careers"
        title="Join our growing team"
        subtitle="Build a rewarding career in contact centre operations, claims processing and B2B sales. We're always looking for talented, motivated people."
        image={images.salesTeam2}
      />

      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-6">
          {perks.map(({ Icon, title, desc }) => (
            <div key={title} className="rounded-2xl border border-border p-8 card-lift">
              <div className="w-12 h-12 rounded-xl brand-gradient flex items-center justify-center mb-5">
                <Icon size={22} className="text-gold-light" />
              </div>
              <h3 className="font-heading font-bold text-navy text-lg mb-2">{title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-secondary py-20">
        <div className="max-w-4xl mx-auto px-6">
          <SectionHeading center eyebrow="Open Positions" title="Current openings" />
          <div className="space-y-4">
            {jobs.map((j) => (
              <div key={j.title} className="bg-white rounded-xl border border-border p-6 flex flex-col md:flex-row md:items-center gap-4 card-lift">
                <div className="flex-1">
                  <h3 className="font-heading font-bold text-navy text-lg">{j.title}</h3>
                  <p className="text-sm text-muted-foreground mt-1 mb-3">{j.desc}</p>
                  <div className="flex flex-wrap gap-4 text-xs text-muted-foreground">
                    <span className="inline-flex items-center gap-1.5"><MapPin size={14} className="text-gold-dark" /> {j.location}</span>
                    <span className="inline-flex items-center gap-1.5"><Briefcase size={14} className="text-gold-dark" /> {j.type}</span>
                  </div>
                </div>
                <a href="mailto:contact@midatlantic-bps.com?subject=Job Application" className="inline-flex items-center gap-2 rounded-md bg-navy px-5 py-3 text-sm font-bold text-white hover:bg-navy-light transition-colors shrink-0">
                  Apply <ArrowRight size={15} />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABanner title="Don't see the right role?" subtitle="Send us your resume and we'll reach out when a matching position opens up." />
    </div>
  );
};

export default Jobs;
